export function getApiBaseUrl(): string {
  const config = useRuntimeConfig();
  return config.public.apiBaseUrl;
}

export function createApiUrl(path: string): string {
  const baseUrl = getApiBaseUrl();
  return `${baseUrl}${path}`;
}
